import P from '../../pages';
import React from 'react';
import { injectIntl } from 'react-intl';
import { defaultMessages } from '../../../../libs/i18n/default';
import FormHeader from './FormHeader';
import Redirector from './Redirector';
import CheckboxOrRadioGroup from './CheckboxOrRadioGroup';
import FormControl from 'react-bootstrap/lib/FormControl';
import Home from 'react-icons/lib/md/home';
import ButtonGroup from './ButtonGroup';
import CustomFormGroup from './CustomFormGroup';
import ProfileElementField from './ProfileElementField';
import { pageValid, executeValidations, shouldValidateProfileElement, toggleValidations } from '../../validator';
import { setProfileElementsFromState, handleSelection, changeState } from '../../utilities';

class FamilyInterests extends React.Component {
  constructor(props){
    super(props);
    let familyInterestSelections = this.props.localProfileElements.elements.lifestyle.family_interest_selections
    let familyInterests = setProfileElementsFromState(this.props.profileElements, [], 'lifestyle', 'family_interests').filter(f => familyInterestSelections.flat().includes(f))
    let familyInterestsOther = setProfileElementsFromState(this.props.profileElements, '','lifestyle','family_interests_other')
    let validateFamilyInterests = shouldValidateProfileElement(this, 'familyInterests')
    let validateFamilyInterestsOther = validateFamilyInterests && familyInterests.includes('Other')
    this.state = {
      familyInterests: { val: familyInterests, validationKey: validateFamilyInterests ? 'profile_elements_lifestyle_family_interests' : '' },
      familyInterestsOther: { val: familyInterestsOther, validationKey: validateFamilyInterestsOther ? 'profile_elements_home_family_interests_other' : '' },
      familyInterestSelections: familyInterestSelections,
    };
    this.submit = this.submit.bind(this);
    this.back = this.back.bind(this);
    this.changeState = this.changeState.bind(this);
    this.handleFamilyInterest = this.handleFamilyInterest.bind(this);
  }

  componentWillMount(){
    executeValidations(this)
  }

  changeState = async(id, val) => {
    if (id == 'familyInterests'){
      toggleValidations(this, val.includes('Other'), 'familyInterests', 'familyInterestsOther', 'profile_elements_lifestyle_family_interests_other')
    }
    changeState(this, id, val)
  }
  handleFamilyInterest(e){
    this.changeState('familyInterests', handleSelection(this.state.familyInterests.val, e.target.value))
  }

  back(e) {
    e.preventDefault();
    this.props.onGoBack();
  }

  submit(e) {
    this.props.onHostProfileSubmit(
      {
        lifestyle: {
          family_interests: this.state.familyInterests.val,
          family_interests_other: this.state.familyInterestsOther.val,
        }
      }
    );
  }

  render() {
    const thisPage = P.FAMILY_INTERESTS_PAGE;
    const { formatMessage } = this.props.intl;
    const content = this.props.content;
    const page = this.props.page;

    return (
      <div id={page} className='profile'>
        <Redirector this_page={thisPage} page={page}/>

        <form onSubmit={this.submit}>
          <FormHeader title={content.pages.family_interests.title} icon={<Home />}/>
          <p>{content.pages.family_interests.body}</p>

          <ProfileElementField
            childComponent={
              <div>
                <CheckboxOrRadioGroup
                  setName={'family_interests'}
                  type={'checkbox'}
                  controlFunc={this.handleFamilyInterest}
                  options={this.state.familyInterestSelections}
                  selectedOptions={this.state.familyInterests.val}
                  valid={this.state.familyInterests.valid}
                />
                {
                  this.state.familyInterests.val.includes('Other') &&
                  <CustomFormGroup valid={this.state.familyInterestsOther.valid}>
                    <FormControl
                      id='familyInterestsOther'
                      type="text"
                      style={{width: '100%'}}
                      componentClass="input"
                      placeholder={formatMessage(defaultMessages.clientCommonDetails)}
                      defaultValue={this.state.familyInterestsOther.val}
                      onChange={e => this.changeState(e.target.id, e.target.value)}
                    />
                  </CustomFormGroup>
                }
              </div>
            }
            elementName='family_interests'
          />

          <ButtonGroup
            backFunc={this.back}
            submitFunc={this.submit}
            disableSubmit={!pageValid(this.state, this.props.requiredFields)}
            page={thisPage}
            user={this.props.user}
            intl={this.props.intl}
          />
        </form>
      </div>
    )
  }
};

FamilyInterests.propTypes = {
   onHostProfileSubmit: PropTypes.func,
   onSkipSubmit: PropTypes.func,
   onGoBack: PropTypes.func,
   page: PropTypes.string,
   intl: PropTypes.object,
   content: PropTypes.object
};

export default injectIntl(FamilyInterests);

